import React from 'react';
import { Radio, Typography } from 'antd';
import { yesNoUnknownOptions } from '../utils/constants';

const { Text } = Typography;

export default function QuestionCheck({ number, title, question, detail, value, onChange, loading }) {
  return (
    <div className="glp1-step">
      <div className="glp1-step-header">
        <span className="glp1-step-number">{number}</span>
        <div>
          <Text className="glp1-step-title">{title}</Text>
          <Text className="glp1-step-detail">{question}</Text>
          {detail ? <Text className="glp1-step-detail">{detail}</Text> : null}
        </div>
      </div>
      <div className="glp1-step-controls">
        <Radio.Group
          value={value}
          onChange={(event) => onChange(event.target.value)}
          disabled={loading}
          options={yesNoUnknownOptions}
          optionType="button"
          buttonStyle="solid"
        />
      </div>
    </div>
  );
}
